
const spfction = {
  install(Vue, options) {


    //判断字符串是否在数组内
    Vue.prototype.in_configs = function (id) {

      let configs = localStorage.getItem("configs");
      // console.log(">>>JSON.parse(sessionStorage.configs)===", configs);

      let arr = [], array = configs ? JSON.parse(configs) : [];

      for (let i = 0; i < array.length; i++) {
        let temp1 = array[i]
        arr.push(temp1.id);
        if (temp1.children && temp1.children.length > 0) {
          temp1.children.forEach(item => {
            arr.push(item.id)
            if(item.children){
              arr = [...arr, ...item.children.map(a=>a.id)] // es6 数组合并
            }

          })
        }
      }
      if (arr.indexOf(id) > -1) return true;
      return false;
    }

    //定义指令
    Vue.directive("uname", {
      bind() {
        console.log("bind"); // 只会调用一次
      },
      update(el, binding, vnode) {
        console.log(el);
        console.log(binding);
        console.log(vnode);
      },
    })
  }
}

if (typeof window !== 'undefind' && window.Vue) {
  window.Vue.use(spfction);
}

export default spfction



// WEBPACK FOOTER //
// ./src/spfction.js